const PagesKeys = {
  STATIONS: "STATIONS",
  PROMO: "PROMO",
  PRODUCTS: "PRODUCTS",
  ORDER_SUMMARY: "ORDER_SUMMARY",
  SHIFT_RECORDS: "SHIFT_RECORDS",
  DISCOUNT_REPORT: "DISCOUNT_REPORT",
};

export default PagesKeys;
